angular.module('qkr')
    .factory('appConfigService', (newAppConfig, $window) => ({

        createUrl(path) {
            return $window.location.origin + newAppConfig.context + path;
        }

    }));




// WEBPACK FOOTER //
// ./src/shared/appconfig.service.js